import React, { useState } from "react";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import ScrollableModal from "../../../../../components/Universal/ScrollableModal.component";
import CustomBill from "../../../../../components/Universal/CustomBill.component";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import DatePicker from "../../../../../components/Universal/DatePicker.component";
import UniversalTable from "../../../../../components/Universal/Tables/UniversalTable.component";
import FormInput from "../../../../../components/Universal/FormInput.component";
import { Formik } from "formik";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const Body = ({
  columns = [],
  historyData = [],
  isReceiptOpen,
  setIsReceiptOpen,
}) => {
  const [showHistory, setShowHistory] = useState(false);
  const [submittedValues, setSubmittedValues] = useState(null);
  const [showSuccess, setShowSuccess] = React.useState(false);

  // Helper component to render each field
  const Field = ({ label, value, multiline = false }) => (
    <div style={{ marginBottom: "1.2rem", paddingRight: "1rem" }}>
      <div
        style={{
          fontSize: "0.9rem",
          color: "#bbb",
          marginBottom: "0.25rem",
          fontWeight: 400,
        }}
      >
        {label}
      </div>
      <div
        style={{
          whiteSpace: multiline ? "pre-wrap" : "nowrap",
          fontWeight: 400,
          color: "#222",
          lineHeight: "1.5",
        }}
      >
        {value || "-"}
      </div>
    </div>
  );

  const formatAmount = (amount) =>
    new Intl.NumberFormat("en-IN").format(Number(amount || 0));

  const data = {
    customerId: "XYZ021",
    provider: "WBSEDCL",
    totalBill: 23980,
    paidAmount: 20453,
    forMonth: ["January", "February", "March"],
    billingDate: "02 Oct, 2025",
    chargePerUnit: 10,
    confirmedBy: "Javed Habib",
  };

  if (showHistory)
    return (
      <section className="ElectricBillHistorySection">
        <ScrollableModal
          isOpen={isReceiptOpen}
          onClose={() => setIsReceiptOpen(!isReceiptOpen)}
        >
          {isReceiptOpen && <CustomBill data={submittedValues} vendorInfo={[]} />}
        </ScrollableModal>
        <Helmet>
          <title>All payments history</title>
          <meta
            name="description"
            content="Monitor and analyze cash inflow trends and contributions."
          />
          <meta
            name="keywords"
            content="All payments history, cash outflow, financial dashboard, cash flow analysis, business finance"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
        <PageHeader title={"All payments history"} />
        <div
          style={{
            marginTop: "1rem",
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "10px",
          }}
          className="HistorySection"
        >
          <div className="history-header mb-1">
            <h3
              style={{
                color: "var(--grayColor)",
                fontWeight: "500",
                marginBottom: "0.5rem",
              }}
            >
              All food items and equipment payment history
            </h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="inputs-buttons"
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                className="input"
              >
                <div className="searchInputContainer">
                  <button className="searchBtn">
                    <img src={SearchIcon} alt="Search" />
                  </button>
                  <input
                    type="text"
                    className="pageHeaderInput"
                    placeholder="Search id"
                  />
                </div>
                <DatePicker
                  label=""
                  name="date"
                  setFieldValue={() => {}}
                  placeholder={"Choose a date"}
                  errors={() => {}}
                />
              </div>
              <div style={{ display: "flex", gap: "1rem" }} className="buttons">
                <button
                  style={{
                    backgroundColor: "var(--blueColor1)",
                    borderColor: "var(--blueColor1)",
                  }}
                  onClick={() => setShowHistory(false)}
                  className="actionBtn"
                >
                  Go to electric billing
                </button>
                <button className="actionBtn">Download</button>
              </div>
            </div>
          </div>
          <div className="history-table">
            <UniversalTable
              columns={columns}
              data={historyData}
              maxBodyHeight="340px"
              footer={
                <div className="Amount-Indicators">
                  <div className="indicator-group">
                    <span className="indicator-box filled-orange">
                      Total count: <span className="text-white">236</span>
                    </span>

                    <span className="indicator-box outlined-orange">
                      Due amount:{" "}
                      <span className="text-orange">₹ 2,60,560</span>
                    </span>
                  </div>

                  <div className="indicator-group">
                    <span className="indicator-box outlined-blue">
                      Total amounts:{" "}
                      <span className="text-blue-light">₹ 2,60,560</span>
                    </span>

                    <span className="indicator-box filled-blue">
                      Paid amount:{" "}
                      <span className="text-white">₹ 2,60,560</span>
                    </span>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </section>
    );

  return (
    <section className="ElectricBillingBody">
      <Helmet>
        <title>Dashboard</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="cash outflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Electric Bill"} />
      <ScrollableModal
        isOpen={isReceiptOpen}
        onClose={() => setIsReceiptOpen(!isReceiptOpen)}
      >
        {isReceiptOpen && <CustomBill data={[]} vendorInfo={[]} />}
      </ScrollableModal>

      <div
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem" }}
        className="ElectricBilling mt-2"
      >
        <div
          style={{ background: "white", padding: "2rem", borderRadius: "10px" }}
          className="ElectricBilling__left"
        >
          <h2
            style={{
              color: "var(--grayColor)",
              fontWeight: "normal",
              borderBottom: "1px solid #ccc",
              paddingBottom: "0.5rem",
              marginBottom: "1rem",
            }}
          >
            Manage electric billing manually{" "}
          </h2>

          <Formik
            initialValues={{
              customerId: "",
              provider: "",
              totalBill: "",
              paidAmount: "",
              forMonth: "",
              billingDate: "",
              chargePerUnit: "",
              confirmedBy: "",
            }}
            onSubmit={(values) => {
              console.log("Bill Form Submitted:", values);
              setSubmittedValues(values);
            }}
          >
            {({ setFieldValue, handleSubmit, touched, errors, setTouched }) => (
              <form onSubmit={handleSubmit} className="accommodationForm">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "1rem",
                  }}
                  className="formGrid"
                >
                  <FormInput
                    label="Customer id"
                    name="customerId"
                    placeholder="Enter customer id"
                    setFieldValue={(e) =>
                      setFieldValue("customerId", e.target.value)
                    }
                    touched={touched}
                    errors={errors}
                  />

                  <DropDownInput
                    label="Provider"
                    name="provider"
                    placeholder="Choose Electricity Provider"
                    suggestionList={["ABC", "DEF", "GHI", "JKL"]}
                    setFieldValue={(val) => setFieldValue("provider", val)}
                    touched={touched}
                    errors={errors}
                  />

                  <FormInput
                    label="Total bill (INR)"
                    name="totalBill"
                    type="number"
                    placeholder="Enter total bill amount"
                    setFieldValue={(e) =>
                      setFieldValue("totalBill", e.target.value)
                    }
                    touched={touched}
                    errors={errors}
                  />

                  <FormInput
                    label="Paid amount (INR)"
                    name="paidAmount"
                    type="number"
                    placeholder="Enter paid amount"
                    setFieldValue={(e) =>
                      setFieldValue("paidAmount", e.target.value)
                    }
                    touched={touched}
                    errors={errors}
                  />

                  <FormInput
                    label="For month"
                    name="forMonth"
                    placeholder="Choose Multiple months"
                    setFieldValue={(e) =>
                      setFieldValue("forMonth", e.target.value)
                    }
                    touched={touched}
                    errors={errors}
                  />
                  <DatePicker
                    name="billingDate"
                    label="Billing date"
                    placeholder="Choose billing date"
                    setFieldValue={(val) => setFieldValue("billingDate", val)}
                    errors={errors}
                  />

                  <FormInput
                    label="Charge per unit(INR)"
                    name="chargePerUnit"
                    placeholder="Enter charge per unit"
                    setFieldValue={(e) =>
                      setFieldValue("chargePerUnit", e.target.value)
                    }
                    touched={touched}
                    errors={errors}
                  />

                  <DropDownInput
                    name="confirmedBy"
                    label="Confirmed by"
                    placeholder="Choose confirmed by"
                    suggestionList={["Manager", "Admin", "Finance Team"]}
                    setFieldValue={(val) => setFieldValue("confirmedBy", val)}
                    setTouched={(name, isTouched) =>
                      setTouched({ [name]: isTouched })
                    }
                    touched={touched}
                    errors={errors}
                  />
                </div>

                <button
                  style={{ width: "100%", marginTop: "1rem" }}
                  type="submit"
                  className="submitBtn actionBtn"
                >
                  update
                </button>
              </form>
            )}
          </Formik>
        </div>
        <div
          style={{
            background: "white",
            padding: "2rem",
            borderRadius: "10px",
          }}
          className="ElectricBilling__right"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingBottom: "1rem",
              borderBottom: "1px solid #ccc",
            }}
          >
            <h2 style={{ color: "var(--grayColor)", fontWeight: "normal" }}>
              Confirmation of payment
            </h2>
            <button
              onClick={() => setShowHistory(true)}
              style={{ height: "2.5rem" }}
              className="blueActionBtnLight"
            >
              All payments history{" "}
            </button>
          </div>
          {showSuccess ? (
            <div className="billSuccess">
              <h2
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "var(--deepGreen3)",
                  fontWeight: "500",
                }}
              >
                You have confirm payment successfully
              </h2>
              <p
                style={{
                  marginTop: "1rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Receipt ID: 23456789012
              </p>
              <h4
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5rem",
                  marginBlock: "1rem",
                  fontWeight: "500",
                  fontSize: "1.2rem",
                  color: "var(--blueColor1)",
                  cursor: "pointer",
                }}
                onClick={() => setIsReceiptOpen(true)}
              >
                Receipt <BsBoxArrowRight />
              </h4>
              <button
                style={{ width: "100%" }}
                onClick={() => setShowSuccess(false)}
                className="actionBtn"
              >
                Okay
              </button>
            </div>
          ) : (
            true && (
              <div
                style={{
                  maxWidth: "800px",
                  margin: "auto",
                  padding: "2rem",
                  fontFamily: "sans-serif",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    rowGap: "1.5rem",
                  }}
                >
                  {/* Left Column */}
                  <div style={{ width: "50%" }}>
                    <Field label="Customer id" value={data.customerId} />
                    <Field
                      label="Bill amount (INR)"
                      value={`₹ ${formatAmount(data.totalBill)}`}
                    />
                    <Field
                      label="For Month"
                      value={data.forMonth.map((item) => `${item},`)}
                    />
                    <Field
                      label="Charge per unit (INR)"
                      value={`₹${formatAmount(data.chargePerUnit)}%`}
                    />
                  </div>

                  {/* Right Column */}
                  <div style={{ textAlign: "right", width: "50%" }}>
                    <Field label="Provider" value={data.provider} />
                    <Field
                      label="Paid amount (INR)"
                      value={`₹ ${formatAmount(data.paidAmount)}`}
                    />
                    <Field label="Billing data" value={data.billingDate} />
                    <Field label="Confirmed by" value={data.confirmedBy} />
                  </div>
                </div>

                <button
                  style={{
                    marginTop: "2rem",
                    backgroundColor: "#6c9c5a",
                    color: "#fff",
                    border: "none",
                    width: "100%",
                    padding: "0.9rem",
                    fontSize: "1rem",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowSuccess(true)}
                >
                  Confirm payment
                </button>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Body;
